export const KIVLIK_API_URL =
  process.env.REACT_APP_ENV === "production"
    ? "https://api.kivlik.ca/api/v1/"
    : process.env.REACT_APP_ENV === "staging"
    ? "https://alpha.kivlik.ca/api/v1/"
    : "http://localhost:5000/api/v1/";
